export class FieldEvent
{
    public static BLUR: string = "component:field:blur";
    public static CHANGE: string = "component:field:change";
    public static FOCUS: string = "component:field:focus";
    public static INPUT: string = "component:field:input";
    public static KEYPRESS: string = "component:field:keypress";
    public static UPDATE: string = "component:field:update";
}
